module.exports = __webpack_public_path__ + "kairiceleste.webp?bd4879f2e7880dc2718e5e15119b4167";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/kairiceleste.webp
// module id = 278
// module chunks = 0